import { restApiDP } from "@plannel/services/utils/rest-api";

const getStatusDashboard = (data) => {
    return restApiDP.post("/api/status-dashboard", data);
}

const getForecastGraph = (params) => {
    return restApiDP.get("/api/forecast-alert-graph", { params })
};

const getTrendGraph = (params) => {
    return restApiDP.get("/api/sales-trend-graph", { params })
};

const getDemandPlanGraph = (params) => {
    return restApiDP.get("/api/demand-plan-graph", { params })
};

const dpStatusDashboardService = {
    getStatusDashboard,
    getForecastGraph,
    getTrendGraph,
    getDemandPlanGraph
}

export default dpStatusDashboardService;